import type { BookingFileUploadResponse } from '../types/booking.types';

function readString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

function parseNumber(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
}

export function normalizeBookingFileUploadResponse(
  raw: unknown,
): BookingFileUploadResponse {
  if (!raw || typeof raw !== 'object') {
    throw new Error('Invalid booking file upload response');
  }

  const item = raw as Record<string, unknown>;

  return {
    id: parseNumber(item.id),
    fileName: readString(item.fileName),
    filePath: readString(item.filePath),
    fileType: readString(item.fileType),
    fileUrl: readString(item.fileUrl),
    storedDate: readString(item.storedDate),
  };
}
